import React, { useCallback, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import cx from "classnames"
import s from "./Results.module.scss"

import store from "store"
import { setState } from "store/game"
import { setState as setUiState } from "store/ui"
import { getCharacter } from "scripts/util/Character"
import EventPubSub from "scripts/util/EventPubSub"
import { isBadWord } from "scripts/util/ProfanityChecker"

import Background from "assets/images/2024-ui/background-4.jpg"
import InitialsBackground from "assets/images/2024-ui/background-1.jpg";
import Glow from "assets/images/2024-ui/leaderboard-ambient-glow.png";

import BackgroundCorners from "components/BackgroundCorners"
import InitialsPicker from "components/InitialsPicker"
import Leaderboard from "components/Leaderboard"
import GameButton from "components/GameButton/GameButton"

import Firebase from "scripts/util/Firebase"
import AudioManager from "scripts/util/AudioManager"
import useQuery from "hooks/useQuery";

Results.defaultProps = {}

const MOCK_CHARACTER = ""
// const MOCK_CHARACTER = 'yeti'
// const mockResults = {
//   character: 'yeti',
//   points: 1010,
//   winner: true,
// }

const translate = {
  bigLoserHeading: {
    en: "Time is up!",
    es: "¡Se acabó el tiempo!",
  },
  bigLoserText: {
    en: "Try again to get down <br />the mountain.",
    es: "Intenta de nuevo <br />bajar la montaña.",
  },
  noScoreHeading: {
    en: "Nice Score!",
    es: "¡Buen puntaje!",
  },
  noScoreText: {
    en: "Play again to get <br />into the&nbsp;top&nbsp;ten!",
    es: "Juega de nuevo para <br />llegar al top 10.",
  },
  top10Heading: {
    en: "New <br /> high score!",
    es: "¡Nuevo récord!",
  },
  top10SubmitButton: {
    en: "Submit",
    es: "Enviar"
  },
  top10Text: {
    en: "Wow, you set a new record!",
    es: "¡Guau! Estableciste<br />un nuevo récord!",
  },
  scoreEnteredHeading: {
    en: "Score entered!",
    es: "¡Puntuación ingresada!",
  },
  scoreEnteredText: {
    en: "You're top ten in the nation!",
    es: "¡Estás entre los 10 primeros del país!",
  },
  leaderboardLink: {
    en: "National Leaderboard",
    es: "Tablero nacional de posiciones"
  },
  playAgainButton: {
    en: "Play Again",
    es: "Jugar otra vez"
  },
  quitButton: {
    en: "Quit",
    es: "Terminar"
  }
}

export default function Results(props) {
  const lang = useQuery().get("lang") || "en";
  const [characterImg, setCharacterImg] = useState()
  const [initials, setInitials] = useState("AAA")
  const [rank, setRank] = useState(0)
  const [scoreEntered, setScoreEntered] = useState(false)

  const { character, points, winner, leaderboard } = useSelector(
    (state) => state.game
  )
  // const {leaderboard} = useSelector((state) => state.game)
  // const {character, points, winner} = mockResults

  const btnWrapper = useRef(null)

  // Update score
  const enterScore = useCallback(() => {
    if (isBadWord(initials)) {
      EventPubSub.emit("naughty")
      return
    }
    if (scoreEntered) {
      return
    }

    async function fetchLeaderboard() {
      const myLeaderboard = await Firebase.getLeaderboard()
      store.dispatch(setState({ leaderboard: myLeaderboard }))
    }

    // TODO: Get it workin' yo
    Firebase.updateLeaderboard({
      initials,
      score: points,
    })

    setTimeout(fetchLeaderboard, 250)

    setScoreEntered(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rank, initials, scoreEntered])

  // Check rank and setup character image
  useEffect(() => {
    if (winner === false) {
      setCharacterImg(getCharacter(MOCK_CHARACTER || character).imgSad)
    } else if (rank >= 0) {
      setCharacterImg(getCharacter(MOCK_CHARACTER || character).imgHappy)
    } else {
      setCharacterImg(getCharacter(MOCK_CHARACTER || character).imgHappy)
    }

    const lowerScore = leaderboard.find((entry) => entry.score < points)

    if (lowerScore && winner) {
      setRank(leaderboard.indexOf(lowerScore))
    } else {
      setRank(-1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const exitGame = () => {
    AudioManager.playSound("uiAccept")
    EventPubSub.emit("exitGame")
  }

  const playAgain = () => {
    AudioManager.playSound("uiAccept")
    EventPubSub.emit("playAgain")
  }

  const exitBtns = () => {
    return (
      <div className={s.buttonWrapper} ref={btnWrapper}>
        <GameButton className={s.GameButton} onClick={playAgain}>
          {translate.playAgainButton[lang]}
        </GameButton>
        <GameButton className={s.GameButton} onClick={exitGame}>
          {translate.quitButton[lang]}
        </GameButton>
      </div>
    )
  }

  const determineStatus = () => {
    if (!scoreEntered && rank >= 0) {
      return "TOP_10"
    }
    if (scoreEntered && rank >= 0) {
      return "SCORE_ENTERED"
    }
    if (rank < 0 && winner) {
      return "NO_SCORE"
    }
    if (rank < 0 && !winner) {
      return "BIG_LOSER"
    }
  }

  return (
    <div
      className={cx(s.Results, {
        [s.lowRank]: rank < 0,
        [s.highRank]: rank >= 0,
        [s.scoreEntered]: scoreEntered,
        [s.noTime]: winner === false,
      })}
    >
      <div className={s.background}>
        <img className={s.bg} src={Background} alt="" />
      </div>
      <div className={s.content}>
        <div className={s.contentInner}>
          {/* Top 10 - Enter Score */}
          {determineStatus() === "TOP_10" && (
            <div className={s.initialsWrap}>
              {/* <img className={s.newHighScore} src={NewHighScore} alt="New High Score" /> */}
              <div className={s.initialsInner}>
                <h1 className={`screenTitle ${s.newHightScore}`} dangerouslySetInnerHTML={{__html: translate.top10Heading[lang]}}></h1>
                <p className={s.congratulate} dangerouslySetInnerHTML={{__html: translate.top10Text[lang]}}></p>
                <InitialsPicker
                  className={s.InitialsPicker}
                  initials={initials}
                  onUpdate={setInitials}
                />
                <GameButton
                  className="md"
                  onClick={() => {
                    AudioManager.playSound("uiAccept")
                    enterScore()
                  }}
                >
                  { translate.top10SubmitButton[lang] }
                </GameButton>
              </div>
              <div className={s.initialsBackground}>
                <img className={s.bg} src={InitialsBackground} alt="" />
                <img className={s.bg} src={Glow} alt="" />
                <BackgroundCorners />
              </div>
            </div>
          )}
          {/* Top 10 - Score Entered */}
          {determineStatus() === "SCORE_ENTERED" && (
            <>
              {/* <img className={s.newHighScore} src={ScoreEntered} alt="Score Entered" /> */}
              <h1 className={`screenTitle ${s.newHighScore}`}>
                {translate.scoreEnteredHeading[lang]}
              </h1>
              <div className={s.menuInner}>
                <Leaderboard
                  className={s.Leaderboard}
                  rank={rank < 0 ? null : rank}
                />
              </div>
              <p className={s.resultMsg}>
                {translate.scoreEnteredText[lang]}
              </p>
              {exitBtns()}
            </>
          )}
          {/* Top 10 - No Score */}
          {determineStatus() === "NO_SCORE" && (
            <>
              {/* <img className={s.newHighScore} src={YouDidGreat} alt="You Did Great" /> */}
              <h1 className={`screenTitle ${s.newHightScore}`} dangerouslySetInnerHTML={{__html: translate.noScoreHeading[lang]}}></h1>
              <h3 className={s.points}>{points.toLocaleString()}</h3>
              <img
                className={cx(
                  s.character,
                  s[MOCK_CHARACTER || character],
                  s.win
                )}
                src={characterImg?.src}
                alt={characterImg?.alt}
              />
              <p className={s.resultMsg} dangerouslySetInnerHTML={{__html: translate.noScoreText[lang]}}></p>
              <button
                className={cx(s.link, "link")}
                onClick={() => {
                  AudioManager.playSound("uiSelect");
                  store.dispatch(setUiState({ showLeaderboard: true }));
                }}
              >
                {translate.leaderboardLink[lang]}
              </button>
              {exitBtns()}
            </>
          )}
          {/* Big Loser */}
          {determineStatus() === "BIG_LOSER" && (
            <>
              {/* <img className={s.newHighScore} src={OutOfTime} alt="Out of Time" /> */}
              <h1 className={`screenTitle ${s.newHighScore}`} dangerouslySetInnerHTML={{__html: translate.bigLoserHeading[lang]}}></h1>
              <img
                className={cx(
                  s.character,
                  s[MOCK_CHARACTER || character],
                  s.lose
                )}
                src={characterImg?.src}
                alt={characterImg?.alt}
              />
              <p className={s.resultMsg} dangerouslySetInnerHTML={{__html: translate.bigLoserText[lang]}}></p>
              <button
                className={cx(s.link, "link")}
                onClick={() => {
                  AudioManager.playSound("uiSelect");
                  store.dispatch(setUiState({ showLeaderboard: true }));
                }}
              >
                {translate.leaderboardLink[lang]}
              </button>
              {exitBtns()}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
